import { gql } from '@apollo/client/core';

export interface SubmissionSetFieldMutationData {
  submission: {
    id: string;
    percentageComplete: string;
  };
}

export interface SubmissionSetFieldMutationVariables {
  submission: string;
  fields: [field: { token: string; field: string; data: string }];
}

export const SUBMISSION_SET_FIELD_MUTATION = gql`
  mutation submissionSetField(
    $submission: ID!
    $fields: [SubmissionSetFieldInput!]!
  ) {
    submission: submissionSetField(submission: $submission, fields: $fields) {
      id
      percentageComplete
    }
  }
`;
